'use client';
import React from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { getIsSignedIn } from 'src/redux/selectors';
import {
  useImpressionEvent,
  useInitializeGtm,
  useUserNavigatedEvent,
} from 'src/utils/analytics/hooks';
import { CtaSection } from './cta-section';
import DataSection from './data-section';
import EtcSection from './etc-section';
import HeroSection from './hero-section';
import { HowItWorks } from './how-it-works';
import ShowCaseSection from './show-case-section';
import { AnalyticsPageView } from '@nerdwallet-cards/analytics';
import { EntityName, EventType } from 'src/utils/analytics/constants';
import useSegmentRegistrationAttributes from '../../utils/useSegmentRegistrationAttributes';
import { SatellitePageViewRegistration } from '../../components/SatellitePageViewRegistration';

export type JumpPageSectionProps = {
  analytics: { navigationId: string; impressionId?: string };
};

const JumpPageBody = (): JSX.Element => {
  const { navigationId } = useUserNavigatedEvent();
  const isSignedIn = useAppSelector(getIsSignedIn);

  useInitializeGtm({
    isSignedIn,
    navigationId,
  });

  const { impressionId } = useImpressionEvent({
    eventType: EventType.PageImpression,
    immediate: true,
    navigationId,
    payload: {
      entity_name: EntityName.Jump,
    },
  });
  useSegmentRegistrationAttributes(
    {
      driverPageViewId: impressionId,
      driverPageName: EntityName.Jump,
    },
    []
  );

  const analytics = {
    navigationId,
    impressionId,
  };

  return (
    <AnalyticsPageView name={EntityName.Jump}>
      <SatellitePageViewRegistration>
        <HeroSection analytics={analytics} />
        <HowItWorks analytics={analytics} />
        <EtcSection analytics={analytics} />
        <ShowCaseSection analytics={analytics} />
        <DataSection analytics={analytics} />
        <CtaSection analytics={analytics} />
      </SatellitePageViewRegistration>
    </AnalyticsPageView>
  );
};

export default JumpPageBody;
